// Polyfill modern JS to support Edge / ie 11
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// Mistify Design Systen
import '@/app/modules/_shared/mistify';
import './assets/css/mistify.css';

// AWS Amplify
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';

// Core
import Vue from 'vue';
import Rollbar from 'rollbar';
import VueGtm from '@gtm-support/vue2-gtm';

// Plugins
import VueBrowserUpdate from '@sum.cumo/vue-browserupdate';
import Vuelidate from 'vuelidate';
import PortalVue from 'portal-vue';
import Mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import router from './app/router/router';
import store from './app/store/store';

// filters
import Filters from './app/filters/filters';

// directives
import Directives from './app/directives/directives';

import '@/app/services/api-interceptors';

import App from './app/app.vue';

import awsconfig from './aws-exports';

Amplify.configure(awsconfig);

Vue.use(AmplifyPlugin, AmplifyModules);

Vue.use(VueBrowserUpdate, {
  options: {
    text_for_i: {
      msg: 'Your browser ({brow_name}) is a little old! This site no longer supports Internet Explorer.',
      msgmore: 'Update your browser as soon as possible to use the Heffron Super Toolkit.',
    },
    required: {
      i: 999, f: -2, o: -2, s: -2, c: -2, e: -2,
    },
  },
  test: false,
});
Vue.use(Vuelidate);
Vue.use(PortalVue);
Vue.use(Filters);
Vue.use(Directives);

Vue.config.productionTip = false;

// Setup Rollbar
// Can use Rollbar in components by this.vm.$rollbar.error('Some Error')
Vue.prototype.$rollbar = new Rollbar({
  accessToken: `${process.env.VUE_APP_ROLLBAR_CLIENT_TOKEN}`,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: `${process.env.VUE_APP_ENV}`,
  },
});
Vue.prototype.$rollbar.configure({
  checkIgnore(isUncaught, args, payload) {
    if (
      payload.level === 'error'
      && (
        payload.body.trace.exception.message.includes('Navigation cancelled from')
        || payload.body.trace.exception.message.includes('NavigationDuplicated')
      )
    ) {
      return true;
    }
    return false;
  },
});

Vue.prototype.$cookies = Cookies;

if (process.env.NODE_ENV !== 'development') {
  Vue.config.errorHandler = (err, vm) => {
    vm.$rollbar.error(err);
    throw err; // rethrow
  };
}

// Setup Mixpanel
// Can use Mixpanel in components by this.$mixpanel.<some operation>('Some value')
Mixpanel.init(process.env.VUE_APP_MIXPANEL_TOKEN);
Vue.prototype.$mixpanel = Mixpanel;

// Setup GTM
Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_ID,
  queryParams: {
    gtm_auth: process.env.VUE_APP_GTM_TOKEN,
    gtm_preview: process.env.VUE_APP_GTM_ENV,
    gtm_cookies_win: 'x',
  },
  defer: true,
  nonce: 'asdf23asdf',
  trackOnNextTick: true,
  vueRouter: router,
});


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
